<div class="container" role="dialog" aria-labelledby="dialog-title" aria-describedby="dialog-description">
	<h1 id="dialog-title" class="title">{{ 'leave_popover.title' | translate }}</h1>
	<p id="dialog-description" class="info">{{ 'leave_popover.info' | translate }}</p>

	<div class="button-group" role="group" aria-label="Choose action">
		<button
			id="main-action"
			(click)="dismiss(leaveEnum.NAVIGATE_BACK)"
			class="button button_main"
			type="button"
			tabindex="0"
			[attr.aria-label]="('leave_popover.yes' | translate) + ' - ' + ('leave_popover.yes_description' | translate)"
			autofocus
		>
			{{ 'leave_popover.yes' | translate }}
		</button>

		<button
			(click)="dismiss(leaveEnum.STAY)"
			class="button button_close"
			type="button"
			tabindex="0"
			[attr.aria-label]="('leave_popover.no' | translate) + ' - ' + ('leave_popover.no_description' | translate)"
		>
			{{ 'leave_popover.no' | translate }}
		</button>
	</div>

	<!-- Screen reader instructions -->
	<div class="sr-only" aria-live="polite">
		Use Tab to navigate between options. Press Enter or Space to select. Press Escape to cancel.
	</div>
</div>
